module.exports = __webpack_public_path__ + "img/loc.294065af.svg";